import styled, { css } from 'styled-components';

import { colors, monokaiBackgroundOffset } from 'global/colors';

export const DropdownButton = styled.button`
  cursor: pointer;
  height: 30px;
  width: ${({ width }) => width || '140px'};
  border: 1px solid ${({ isDarkMode }) => (isDarkMode ? colors.black : colors.lightGray)};
  border-radius: 5px;

  background: ${({ isDarkMode }) => (isDarkMode ? monokaiBackgroundOffset : colors.white)};
  box-shadow: none;

  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
`;

export const ButtonLabel = styled.label`
  cursor: pointer;
  width: 100%;
  margin-top: auto;
  font-weight: normal;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${({ isDarkMode }) => (isDarkMode ? colors.fsCyan : colors.black)};
`;

export const DropdownListContainer = styled.section`
  min-width: 100%;
  z-index: 1;
  position: absolute;
  top: 100%;
  ${({ leftDrop }) =>
    css`
      ${leftDrop ? 'right' : 'left'}: 0px;
    `}
  text-align: left;
  background: ${({ isDarkMode }) => (isDarkMode ? monokaiBackgroundOffset : colors.white)};
  border: 1px solid ${({ isDarkMode }) => (isDarkMode ? colors.black : colors.lightGray)};
  border-radius: 5px;
  box-shadow: 0px 6px 12px -3px ${colors.black};
  padding: 5px 0px 5px;
`;

export const DropdownItemButton = styled.button`
  all: unset;
  cursor: pointer;
  width: 100%;
  margin-top: auto;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  color: ${({ isDarkMode }) => (isDarkMode ? colors.fsCyan : colors.black)};
  :hover {
    background: ${({ isDarkMode }) => (isDarkMode ? colors.black : colors.lightGray)};
  }
  :focus {
    background: ${({ isDarkMode }) => (isDarkMode ? colors.black : colors.lightGray)};
  }
`;

export const DropdownItemLabel = styled.label`
  cursor: pointer;
  padding: 0px 5px;
  margin: 0px;
`;

export const ExpandIcon = styled.i.attrs(() => ({
  className: 'fa fa-caret-down',
}))`
  color: ${({ isDarkMode }) => (isDarkMode ? colors.fsCyan : colors.black)};
  transition: transform 0.35s ease-in-out;
  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: rotate(180deg);
    `}
`;

export const DropdownButtonContainer = styled.span`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const DropdownButtonLeft = styled.button`
  height: 30px;
  border: 1px solid ${({ isDarkMode }) => (isDarkMode ? colors.black : colors.lightGray)};
  border-radius: 5px 0px 0px 5px;
  border-right: none;

  background: ${({ isDarkMode }) => (isDarkMode ? monokaiBackgroundOffset : colors.white)};
  box-shadow: none;

  :hover {
    background: ${({ isDarkMode }) => (isDarkMode ? colors.black : colors.lightGray)};
  }
`;

export const DropdownButtonRight = styled.button`
  height: 30px;
  width: 20px;
  border: 1px solid ${({ isDarkMode }) => (isDarkMode ? colors.black : colors.lightGray)};
  border-radius: 0px 5px 5px 0px;

  background: ${({ isDarkMode }) => (isDarkMode ? monokaiBackgroundOffset : colors.white)};
  box-shadow: none;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  :hover {
    background: ${({ isDarkMode }) => (isDarkMode ? colors.black : colors.lightGray)};
  }
`;
